export const RECT_SIZE = 7;
export const MSEC_PER_GENERATION = 20;

export interface GridPoint{
    x: number;
    y: number;
}

export interface CellType {
    x: number;
    y: number;
}


